/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import { MdSkipPrevious, MdSkipNext } from 'react-icons/md'
import { useLesson } from 'querys/lesson'

const ClassNavigationStyled = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
  .next, .prev {
    user-select: none;
  }
  a {
    color: var(--turquoise);
    font-family: var(--secondaryFont);
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    padding: 0 1rem 0;
    font-weight: 500;
    :hover {
      color: var(--baseSecondary);
    }
  }
  .prev {
    padding-left: 0;
    user-select: none;
    svg {
      margin-right: 4px;
    }
  }
  .next {
    justify-content: flex-end;
    padding-right: 0;
    user-select: none;
    svg {
      margin-left: 4px;
    }
  }
  .disabled:hover {
    color: #AEB7C1;
  }
  @media(min-width: 1024px) {
    margin: 0;
    grid-area: navigation;
  }
`

function ClassNavigation() {
  const {
    data: {
      course: { slug },
      lesson_navigation: { prev, next },
    },
  } = useLesson()
  return (
    <ClassNavigationStyled>
      {prev ? (
        <Link className="prev" href={`/aprender/${slug}/${prev?.slug}`}>
          <MdSkipPrevious size={24} />
          {' '}
          Anterior
        </Link>
      ) : (
        <a className="prev disabled">
          <MdSkipPrevious size={24} />
          {' '}
          Anterior
        </a>
      )}
      {next ? (
        <Link className="next" href={`/aprender/${slug}/${next?.slug}`}>
          Siguiente
          {' '}
          <MdSkipNext size={24} />
        </Link>
      ) : (
        <a className="next disabled">
          Siguiente
          {' '}
          <MdSkipNext size={24} />
        </a>
      )}
    </ClassNavigationStyled>
  )
}

export default ClassNavigation
